import { render } from "./UserSettings.vue?vue&type=template&id=fcc17332"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/user_profile/UserSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcc17332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcc17332', __exports__)) {
    api.reload('fcc17332', __exports__)
  }
  
  module.hot.accept("./UserSettings.vue?vue&type=template&id=fcc17332", () => {
    api.rerender('fcc17332', render)
  })

}


export default __exports__